import ShareIcon from "@mui/icons-material/Share";
import { useRouter } from "next/router";
import { FunctionComponent } from "react";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import Logo from "../assets/images/logo.svg";
import { Button } from "./Button";
import styles from "./Header.module.css";

interface Props {
  hideSaveButton?: boolean;
  canSave?: boolean;
  onSave?: () => any;
  onDeluxeClick?: () => any;
}

export const Header: FunctionComponent<Props> = ({
  hideSaveButton,
  canSave,
  onSave,
  onDeluxeClick,
}) => {
  const { i18n, t } = useTranslation();
  const router = useRouter();

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <a href="https://kinderkiez.net">
          <img width={100} src={Logo.src} alt="kinderkiez" />
        </a>

        <p className={styles.title}>{t("introduction_title")}</p>

        <Button round size="small" onClick={onDeluxeClick}>
          {t("deluxe-modal_cta")}
        </Button>
      </div>
      {/* TODO: language switch loads translations every time, fix it */}
      <div className={styles.navigation}>
        <Button
          tertiary
          size="small"
          onClick={() => {
            const newLocale = i18n.language === "de" ? "en" : "de";
            router.push(router.pathname, router.asPath, { locale: newLocale });
          }}
        >
          {i18n.language === "en"
            ? t("language_german")
            : t("language_english")}
        </Button>
        {!hideSaveButton && (
          <Button
            disabled={!canSave}
            size="small"
            onClick={(e) => {
              e.preventDefault();
              onSave && onSave();
            }}
          >
            {isMobile ? (
              <ShareIcon
                style={{ margin: -8 }}
                titleAccess={t("button_save")}
              />
            ) : (
              t("button_save")
            )}
          </Button>
        )}
      </div>
    </div>
  );
};
